import { useParams } from 'react-router-dom'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import { Queries } from 'admin/lib/Api'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'
import { CompanyEditForm } from './CompanyEditForm'
import { ShortcutsModalButton } from 'admin/lib/ShortcutsModalButton'

export function CompanyEdit() {
  const { companyId } = useParams()

  const company = Queries.useCompany(companyId)

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.REFERENCE_DATA.INDEX}>
                    Reference Data
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.COMPANIES.LIST}>
                    Companies
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: companyId
              }
            ]}
          />

          <ShortcutsModalButton />
        </>
      }
    >
      {!company.isFetched && <ScreenSpin />}

      {company.isError && <div>{String(company.error)}</div>}

      {company.isFetched && company.data && (
        <CompanyEditForm company={company.data} />
      )}
    </Layout>
  )
}
